import { render, staticRenderFns } from "./NotificationDrawer.vue?vue&type=template&id=c05bbd8a&scoped=true&"
import script from "./NotificationDrawer.vue?vue&type=script&lang=js&"
export * from "./NotificationDrawer.vue?vue&type=script&lang=js&"
import style0 from "./NotificationDrawer.vue?vue&type=style&index=0&id=c05bbd8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05bbd8a",
  null
  
)

export default component.exports